<template>
	<van-popup v-model="visible" position="top" :close-on-click-overlay="false">
		<div class="verified-modal">
			<van-form @submit="onSubmit">
				<van-field
					v-model="defaultRoleInfo.server_name"
					:label="$t('bindRoles.区服名称')"
					readonly
				/>
				<van-field
					v-model="defaultRoleInfo.role_name"
					:label="$t('bindRoles.角色名称')"
					readonly
				/>
				<van-field
					v-model="defaultRoleInfo.role_id"
					:label="$t('accountInfo.角色ID')"
					readonly
				/>
				<van-field
					v-model="mail_code"
					name="mail_code"
					center
					clearable
					required
					:maxlength="6"
					:label="$t('login.code')"
					:placeholder="$t('bindRoles.请输入游戏内邮件验证码')"
					:rules="[
						{
							required: true,
							message: $t('bindRoles.请输入游戏内邮件验证码'),
						},
					]"
				>
					<template #button>
						<van-button
							size="small"
							type="primary"
							@click.stop="sendMailCode"
							native-type="button"
						>
							{{ countdownText }}
						</van-button>
					</template>
				</van-field>
				<div style="margin: 16px" class="btn-box">
					<van-button
						block
						type="default"
						native-type="button"
						@click="handleCancel"
					>
						{{ $t("app.取消") }}
					</van-button>
					<van-button block type="primary" native-type="submit">
						{{ $t("record.提交") }}
					</van-button>
				</div>
			</van-form>
		</div>
	</van-popup>
</template>

<script>
import { mapGetters } from "vuex";
import { apiSendGameMail, apiVerifyEmail } from "@/api/user";
export default {
	props: {
		value: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapGetters(["defaultRoleInfo"]),
		visible: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
		countdownText() {
			if (this.countdown > 0) {
				return this.$t("重新发送") + `(${this.countdown})`;
			}
			return this.$t("options.发送验证码");
		},
	},
	data() {
		return {
			mail_code: "",
			countdown: 0,
		};
	},
	mounted() {
		console.log("%c Line:22 🍷", "color:#3f7cff", this.defaultRoleInfo);
	},
	methods: {
		async sendMailCode() {
			if (this.countdown > 0) return;

			try {
				const { code } = await apiSendGameMail({
					server_id: this.defaultRoleInfo.f_id,
					role: this.defaultRoleInfo.role_id,
				});
				if (code === 0) {
					this.countdown = 60;
					const timer = setInterval(() => {
						this.countdown--;
						if (this.countdown <= 0) {
							clearInterval(timer);
						}
					}, 1000);
				}
			} catch (error) {}
		},
		handleCancel() {
			this.$router.go(-1);
			this.visible = false;
		},
		async onSubmit() {
			try {
				const { code } = await apiVerifyEmail({
					mail_code: this.mail_code,
				});
				if (code === 0) {
					this.visible = false;
					window.location.reload();
				}
			} catch (error) {
				console.log("%c Line:135 🍅 error", "color:#b03734", error);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.verified-modal {
	padding-top: 20px;

	.btn-box {
		display: flex;
		justify-content: space-between;
		gap: 10px;
	}
}
</style>
